let moveArr = [


  {
    ele: [".banner .title"],
    distancetop: 0,
    distancebottom: 500,
    from: { opacity: 1, y: 0 },
    to: { opacity: 0, y: -200 }
  },

  {
    ele: [".page1 .text"],
    distancetop: 100,
    distancebottom: 50,
    from: { opacity: 0.8, scale: 0.5 },
    to: { opacity: 1, scale: 1 }
  },


  {
    ele: [".page1 .title"],
    distancetop: 100,
    distancebottom: 50,
    from: { opacity: 0.8, scale: 0.5 },
    to: { opacity: 1, scale: 1 }
  },


  {
    ele: [".page1 .img"],
    distancetop: 100,
    distancebottom: 50,
    from: { opacity: 0.8, x: 700, y: 200, scale: 1.2 },
    to: { opacity: 1, x: 0, y: 0, scale: 1 }
  },
  {
    ele: [".page1 .bot"],
    distancetop: 600,
    distancebottom: 100,
    from: { opacity: 0, y: 200, scale: 1.2 },
    to: { opacity: 1, y: 0, scale: 1 }
  },

  // {
  //   ele: [".page2 .title"],
  //   distancetop: 1000,
  //   distancebottom: 200,
  //   from: { opacity: 0, x: -2000, scale: 1.2 },
  //   to: { opacity: 1, x: 0, scale: 1 }
  // },


  // {
  //   ele: [".page2 .zs"],
  //   distancetop: 1500,
  //   distancebottom: 200,
  //   from: { opacity: 0, y: 2000, },
  //   to: { opacity: 1, y: 0, }
  // },

  {
    ele: [".page3 .top"],
    distancetop: 900,
    distancebottom: 300,
    from: { opacity: 0, x: -3000, },
    to: { opacity: 1, x: 0, }
  },
  {
    ele: [".page3 .bot .title", ".page3 .bot .text ", ".page3 .bot .copy "],
    distancetop: 1800,
    distancebottom: 100,
    from: { opacity: 0, y: -1000, },
    to: { opacity: 1, y: 0, }
  },




























]
export default moveArr


//////////////////
// WEBPACK FOOTER
// ./static/movedata/about.js
// module id = null
// module chunks = 